import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { Goal, GoalStep } from 'src/app/store/goal/goal.models';

@Component({
  selector: 'app-goal-step-display',
  templateUrl: './goal-step-display.component.html',
  styleUrls: ['./goal-step-display.component.scss']
})
export class GoalStepDisplayComponent implements OnInit {
  @Output() toggleGoalStatus: EventEmitter<any> = new EventEmitter<any>();
  @Input() eventTransmitter: BehaviorSubject<any>;
  @Input() step: GoalStep;
  @Input() goal: Goal;

  updateStepForm: FormGroup;
  showUpdateStepController: boolean = false;
  disabledAddStepButton: boolean = false;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.updateStepForm = this.fb.group({
      description: this.step.description
    });

    this.eventTransmitter.subscribe((val) => {
      if (val.action === 'EDIT_MODE') {
        this.showUpdateStepController = val.data;
      }
    })
  }

  showUpdateStep(): void {
    this.showUpdateStepController = true;
  }

  updateGoal(): void {
    this.step.description = this.updateStepForm.value.description;
    this,this.toggleGoalStatus.emit({data: this.step, action: 'UPDATE_STEP'})
  }

  toggleGoalStatusHandler(): void {
    this.toggleGoalStatus.emit({data: this.step, action: 'TOGGLE_STATUS'});
  }

  deleteStep(): void {
    this.toggleGoalStatus.emit({data: this.step, action: 'DELETE_STEP'});
  }
}
